module.exports = __webpack_public_path__ + "img/相続手続きチェックリスト.4f7f083f.png";